"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageWorldState = exports.sendMessageAndImmediatelyExecute = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = exports.EHostCommand = void 0;
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var voyageGameManager_sidecar_1 = require("@voyage/game-status/voyageGameManager-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
var EHostCommand;
(function (EHostCommand) {
    EHostCommand[EHostCommand["old_Reset"] = 0] = "old_Reset";
    EHostCommand[EHostCommand["old_Clear"] = 1] = "old_Clear";
    EHostCommand[EHostCommand["old_DestroyCrew"] = 2] = "old_DestroyCrew";
    EHostCommand[EHostCommand["old_LoadScenario"] = 3] = "old_LoadScenario";
    EHostCommand[EHostCommand["old_NewScenario"] = 4] = "old_NewScenario";
    EHostCommand[EHostCommand["old_Resume"] = 5] = "old_Resume";
})(EHostCommand = exports.EHostCommand || (exports.EHostCommand = {}));
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.HostCommand;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write8(m, d.command);
    messageWriter_sidecar_1.messageWriter.write32(m, d.crewId || 0);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        command: messageWriter_sidecar_1.messageWriter.read8(m),
        crewId: messageWriter_sidecar_1.messageWriter.read32(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        command: EHostCommand.old_DestroyCrew,
        crewId: 1234,
    };
    messageWriter_sidecar_1.messageWriter.test('host-command', ex, write, read);
}
exports.test = test;
function process(m) {
    var msg = read(m);
    if (msg.command === EHostCommand.old_Reset) {
        console.log('!! HOST COMMAND', 'Reset');
        // voyageGameMode_scenario_new.reset()
    }
    if (msg.command === EHostCommand.old_Clear) {
        console.log('!! HOST COMMAND', 'Clear');
        // voyageGameMode_scenario_new.reset()
    }
    if (msg.command === EHostCommand.old_LoadScenario) {
        console.log('!! HOST COMMAND', 'Load');
        // if (voyageWebsockets.getIsHost()) {
        //   voyageGameManager.goScenario_load()
        // } else {
        //   voyageGameMode_scenario_new.reset()
        // }
    }
    if (msg.command === EHostCommand.old_Resume) {
        console.log('!! HOST COMMAND', 'Resume');
        // if (!voyageWebsockets.getIsHost()) {
        //   voyageGameManager.goGame()
        // }
    }
    if (msg.command === EHostCommand.old_NewScenario) {
        console.log('!! HOST COMMAND', 'New scenario');
        if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
            voyageGameManager_sidecar_1.voyageGameManager.goScenario_generate_new_scenario();
        }
        // if (voyageWebsockets.getIsHost()) {
        //   voyageGameManager.goScenario_new()
        // } else {
        //   voyageGameMode_scenario_new.reset()
        // }
        //voyageGameMode_game.reset(true)
    }
    if (msg.command === EHostCommand.old_DestroyCrew) {
        // let cr = diveCrew.findById(msg.crewId || 0)
        // assert.notNil(cr)
        // diveCrew.kill(cr)
    }
}
exports.process = process;
function sendMessageAndImmediatelyExecute(msg) {
    websockets_sidecar_1.websockets._sendMessageAndImmediatelyExecute(write, msg);
}
exports.sendMessageAndImmediatelyExecute = sendMessageAndImmediatelyExecute;
function sendMessageWorldState(msg, multiId) {
    websockets_sidecar_1.websockets._sendMessageWorldState(write, msg, multiId);
}
exports.sendMessageWorldState = sendMessageWorldState;
